import { useSubscription } from "../context"
import { isDaysWarning, isDaysCritical, isLicensesCritical, isLicensesWarning, getLicensesAvailable } from "../utils"
import { SubscriptionBanner } from "./SubscriptionBanner"

export const SubscriptionBannerController = () => {
  const { role, subscription } = useSubscription()
  if (role !== "admin") return null
  const { status, expiry_date, days_remaining, licenses_consumed, licenses_total } = subscription

  if (status === "expired") {
    return (
      <SubscriptionBanner
        variant="expired"
        expiredDate={expiry_date}
      />
    )
  }

  if (status === "grace_period") {
    return (
      <SubscriptionBanner
        variant="grace_period"
        expiredDate={expiry_date}
        daysRemaining={days_remaining}
      />
    )
  }

  if (status === "active" && days_remaining === 0) {
    return <SubscriptionBanner variant="warning_today" />
  }

  if (status === "active" && isDaysCritical(days_remaining)) {
    return (
      <SubscriptionBanner
        variant="warning_critical"
        expiredDate={expiry_date}
        daysRemaining={days_remaining}
      />
    )
  }

  if (status === "active" && isDaysWarning(days_remaining)) {
    return (
      <SubscriptionBanner
        variant="warning"
        expiredDate={expiry_date}
        daysRemaining={days_remaining}
      />
    )
  }

  if (status === "active" && isLicensesCritical(licenses_consumed, licenses_total)) {
    return (
      <SubscriptionBanner
        variant="licenses_critical"
        licensesAvailable={getLicensesAvailable(licenses_consumed, licenses_total)}
      />
    )
  }

  if (status === "active" && isLicensesWarning(licenses_consumed, licenses_total)) {
    return (
      <SubscriptionBanner
        variant="licenses_warning"
        licensesAvailable={getLicensesAvailable(licenses_consumed, licenses_total)}
      />
    )
  }

  return null
}
